import { countries, currencies } from './config'

import { mapObjectValues } from 'common/utils/object'
import toCurrency from '@klarna/currency'

interface CurrencySettings {
  country?: string
  currency?: string
  provider?: string
  locale?: string
}

let settings: CurrencySettings = {}

const upperCaseObjectValues = mapObjectValues(value =>
  typeof value === 'string' ? value.toUpperCase() : value
)

function negativeFormatting(amount): string {
  return amount.indexOf('-') !== -1 && amount.indexOf('-') !== 0
    ? '- ' + amount.replace(/-/, '')
    : amount
}

function format(numberOrString: number | string = 0, hideDecimalsIfZero = false) {
  const number = parseInt(String(numberOrString), 10)
  const { country, currency, provider, locale } = settings

  if (!currency || !currencies[currency] || !currencies[currency][provider || 'KP']) {
    const explicitDecimal = number / 100

    if (hideDecimalsIfZero && Number.isInteger(explicitDecimal)) {
      return explicitDecimal.toString()
    }

    return explicitDecimal.toFixed(2)
  }

  const unit = currencies[currency][provider || 'KP']
  const countryCode = countries[country]

  const language = locale && locale.split(/-|_/)[0]
  const countryOrLanguage = ['ca'].includes(country.toLowerCase()) ? language : countryCode

  return negativeFormatting(
    toCurrency(number, currency.toLowerCase(), unit, countryOrLanguage, {
      hideDecimalsIfZero
    })
  )
}

function configure(nextSettings: CurrencySettings) {
  settings = upperCaseObjectValues(nextSettings)
}

function isCurrencySupported() {
  return Boolean(currencies[settings.currency])
}

export default { format, configure, isCurrencySupported }
